import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Reactive `prefers-reduced-motion` flag for JS-driven motion (anime.js,
 * Web Animations). CSS transitions/animations are handled globally in
 * index.css; this guards the imperative animations a media query can't reach.
 *
 * @returns {boolean} true when the user has requested reduced motion.
 */
export default function useReducedMotion() {
    const [reduced, setReduced] = useState(() =>
        typeof window !== "undefined" && window.matchMedia
            ? window.matchMedia(QUERY).matches
            : false
    );

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return undefined;
        const mql = window.matchMedia(QUERY);
        const onChange = (e) => setReduced(e.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, []);

    return reduced;
}
